/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner, Button, Modal } from "react-bootstrap";
import Loader from "../loader/loader";
import Layout from "../layout/layout";
import RarityToolCard from "./rarityToolCard";
import GemologicalCharacteristics from "./gemologicalCharacteristics";
import FcrfContext from "../../Context";
import { rarityInstance, withAuth } from "../../config/axios";
import { resultFormating } from "../../utils/resultFormating";
import { getlocalStorage } from "../../utils/getlocalStorage";
import { clientPath, serverPath } from "../../config/key";
import { queryString } from "../../utils/queryString";
import { getFormattedDate } from "../../utils/dateUtils";
import VerticalDropdown from "../verticalDropdown/verticalDropdown";
import { CopyToClipboard } from "react-copy-to-clipboard";
import logo_img from "../../assets/images/offical-report/official-logo.png"
// import img1 from "../../assets/images/rarity_img1.png";
import CharFadeText from "../Animation/CharFadeText";

import {
  SaveIcons,
  HistoryIcons,
  SettingsIcons,
  DiamondIcon,
  // PrintIcon,
  WhitePrintIcon,
} from "../verticalDropdown/svgData";
import RarityHighlightedBox from "./rarityHighlightedBox";
import "./rarityReport.css";
import RarityInfo from "./rarityInfo";
import SaveNotificationModal from "../Models/saveNotificationModal";
import ScrollToTop from "../common/scrolltotop";
import MarketDistribution from "./marketDistribution";
import PrintPopup from "./PrintPopup";
import {formatDateReport} from "../../utils/dateUtils";
import RarityOfficialCard from "./rarityOfficialCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import img1 from "../../assets/images/official-report/desktop-1.jpg"
import img2 from "../../assets/images/official-report/desktop-2.jpg"
import img3 from "../../assets/images/official-report/desktop-3.jpg"
import img4 from "../../assets/images/official-report/desktop-4.jpg"
import img5 from "../../assets/images/official-report/desktop-5.jpg"

import mobileImg2 from "../../assets/images/official-report/2-mobile.png"
import mobileImg1 from "../../assets/images/official-report/1-mobile.png"
import mobileImg3 from "../../assets/images/official-report/3-mobile.png"
import mobileImg4 from "../../assets/images/official-report/4-mobile.png"
import mobileImg5 from "../../assets/images/official-report/5-mobile.png"

import sliderImg1 from "../../assets/images/official-report/big-desktop-1.png"
import sliderImg2 from "../../assets/images/official-report/big-desktop-2.png"
import sliderImg3 from "../../assets/images/official-report/big-desktop-3.png"
import sliderImg4 from "../../assets/images/official-report/big-desktop-4.png"
import sliderImg5 from "../../assets/images/official-report/big-desktop-5.png"

import Loading from "../Animation/Loading";


import Cookie from "js-cookie";
import PrimaryLoading from "../Animation/PrimaryLoadingButton";

const sliderImages = [img1, img2, img3, img4, img5];
const mobileImages = [mobileImg1, mobileImg2, mobileImg3, mobileImg4, mobileImg5];
const images = [sliderImg1, sliderImg2, sliderImg3, sliderImg4, sliderImg5];


const RarityReport = ({ handleBackRairity, handleOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [characteristics, setCharacteristics] = useState({});
  const [bubble_texts, setBubbleText] = useState({});
  const [animationText, setAnimationText] = useState(null);
  const [range_slider, setRangeSlider] = useState({});
  const [labelName, setLabelName] = useState([]);
  const [tooltip_text, setTooltipText] = useState([]);
  const [labelValue, setLabelValue] = useState([]);
  const setContext = useContext(FcrfContext);
  const getContext = useContext(FcrfContext);
  const [companyLogo, setCompanyLogo] = useState("");
  const [custom_branding, setCustomBranding] = useState("0");

  const { dateSetting, savedNotification, setSavedNotification , userCredits } = getContext;

  const [reportData, setReportData] = useState({});
  const {report_number} = reportData?.data || {}
  // eslint-disable-next-line no-unused-vars
  const [reportId, setReportId] = useState({ Id: "", postId: "" });
  const [copied, setCopied] = useState(false);
  const { Id, from } = queryString();
  const [urlValue, setUrlValue] = useState(null);
  const [, setReportGeneratedDate] = useState("");
  const [isPdf, setisPdf] = useState(false);
  const [, setImgScaleVal] = useState(1);
  const [isActive, setisActive] = useState(false);
  const [fromgia] = useState(location?.state?.type === "fromgia");
  // const [nonMember] = useState(true);
  const [nonMember] = useState(location?.state?.from === "non-member");
  
  const [showContent, setShowContent] = useState(false);
  const [showPopup,setShowPopup]=useState(false);
  const [wooCommercePayload   , setWooCommercePayload] = useState({});
  const [show, setShow] = useState(false);
   const [ printReport, setPrintReport ] = useState({
printId: "",
printUrl: "",
  });
  const [printLoading, setPrintLoading] = useState(false);
  const [rarityLabelUrl , setRarityLabelUrl] = useState(null);
  const [rarityLabelLoading, setRarityLabelLoading] = useState(false);
  const [brandingEnable, setBrandingEnable] = useState(true);
  const [showBranding, setShowBranding] = useState(false);
  

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0); 
  const swiperRef = useRef(); 

 const handleOpenModal = (index) => { 
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  if (isMobile) return;

    setSelectedImageIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImageIndex(0);
  };

  useEffect(() => {
    const { action } = location.state ?? {};
    checkBranding();
    // console.log("action =>", location.state);
    if (action !== "Create") {
      getReportById();
    }
    if (action === "Create") {
      // console.log("action =>", location.state);
      const { report, id } = location.state ?? {};
      const { data, graph_texts, bubble_texts, range_slider, postId, printId } =
        report || {};
      const { labelname, graph_tooltip_text, labelvalue } = resultFormating(
        graph_texts,
        range_slider,
        data
      );

      const obj = {
        Id: id,
        postId: postId,
        printId: printId,
      };
      setReportId(obj);
      handleShare(obj);
      setReportData(report);
      setLabelName(labelname);
      setLabelValue(labelvalue);
      setTooltipText(graph_tooltip_text);
      setBubbleText(bubble_texts);
      AnimateStringData(bubble_texts?.D18);
      setRangeSlider(range_slider);
      setCharacteristics(data);

      // setLoading(false);
    }
  }, []);

  // console.log(location?.state?.type === "fromgia", location?.state?.type);
  const handleCreateNewReport = () => {
    window.history.pushState("1", null, "/");
    setContext.setSetps(1);
    navigate("/", {
      state: {
        tab: "tab1",
        showGia: fromgia,
      },
    });
  };

  const AnimateStringData = (inputString) => {
    // console.log({ inputString });
    let Text = inputString?.split("#") || [];

    const parts = Text[1]?.split("~");

    if (parts?.length === 2) {
      const secondString = parts[1].trim().replace(/,/g, "");
      setAnimationText(Number(secondString));
      return secondString;
    } else {
      setAnimationText(null);
      return null;
    }
  };

  const checkBranding = async () => {
    try{
      setLoading(true);
     const response = await rarityInstance().get("users/check-branding"
    );
    console.log("response",response);
    if (response?.data?.status ===200) {
      setShowBranding(response?.data?.enabledBranding);
    }
    setLoading(false);
    }catch(error){
      console.log("error",error);
    }
  
  };

  const getReportById = async () => {
    setLoading(true);
    try {
      const { id } = location?.state || {};
      let postid = id;
      if (from === "diary") {
        postid = `#${Id}`;
      }
      const rairtyID = id?.replace("#", "");
      const response = await withAuth().get(`report/getreport?Id=${rairtyID}`);
      const { status, getReport, companyInfo } = response?.data;

      const { _id, report, timestamp } = getReport || {};
      if (status === 200) {
        const obj = {
          Id: _id,
          postId: postid,
        };
        setReportId(obj);
        const { data, graph_texts, bubble_texts, range_slider } = report || {};
        const { labelname, graph_tooltip_text, labelvalue } = resultFormating(
          graph_texts,
          range_slider,
          data
        );
        setReportGeneratedDate(getFormattedDate(timestamp || new Date()));
        setReportData(report);
        setLabelName(labelname);
        setLabelValue(labelvalue);
        setTooltipText(graph_tooltip_text);
        setBubbleText(bubble_texts);
        AnimateStringData(bubble_texts?.D18);
        setRangeSlider(range_slider);
        setCompanyLogo(companyInfo?.companyLogo || "")
        setCustomBranding(companyInfo?.customBranding || "0")
   
        setCharacteristics(data);
        handleShare(obj);
        setLoading(false);
        const diaryId = localStorage.getItem("sendViewRarity");
        if (from === "diary" && diaryId) {
          try {
            const shareLink = `${clientPath}/share-rarity-report/${obj.Id}`;
            await rarityInstance().post("report/rarity-from-diary", {
              rarityUrl: shareLink,
              rarityReportId: postid,
              reportId: diaryId,
              reportData: report,
            });
            localStorage.removeItem("sendViewRarity");
          } catch (error) {
            console.log("error in rarity-from-diary api", error);
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDownLoadReport = async (toPdf) => {
    setisPdf(true);
    window.open(reportData.extraritypdfUrl);
    setisPdf(false);
    const copyfilterdata = { ...reportData };
    const { is_free } = getlocalStorage();
    copyfilterdata.free = is_free;

    copyfilterdata.type = "Rarity Export";

    copyfilterdata.stringDate = dateSetting?.stringDate;
    copyfilterdata.shareUrl = urlValue;
    copyfilterdata.enabledBranding = brandingEnable;
    
    const response = await rarityInstance().post(
      "report/downloadReport",
      copyfilterdata
    );
    const { status } = response?.data;
    if (status === 200) {
    }
    setisPdf(false);
  };

  const handlePrintReport = async (type) => {
    // const printUrl = reportData.extraritypdfUrl.split("download")[0] + "print/"+ reportId?.printId?.replace("#", "")+".pdf";
    // window.open(printUrl);
     if (printReport?.generateNewPdf) {
      window.open(printReport?.printUrl , "_blank"); 
      return;
    }
    setPrintLoading(true);
    const response = await rarityInstance().post(
      "report/printReport",{
        report_id: reportId?.printId?.replace("#", ""),
          generateNewPdf: type === "new" ? true : false,
      }
    );
    const {  alreadyExist, printId, printUrl, createdAt  } = response?.data;
     console.log("response  of the report==>", response);
    setPrintLoading(false);
    // if (!alreadyExist) {
    //   window.open(printUrl, "_blank");
    //   return
      
    // }
   

   
    setShow( alreadyExist ? true : false);
    setPrintReport({ ...printReport, printId: printId, printUrl: printUrl ,report_date : formatDateReport(createdAt), generateNewPdf: (type === "new" || !alreadyExist) ? true : false });


  };

   const handleRarityLabelPdf = async (type) => {
    window.open(`${serverPath}/report/rarity-label/${reportId?.postId?.replace("#", "") + ".pdf"}` , "_blank");
    

    // if (rarityLabelUrl){
    //   window.open(rarityLabelUrl, "_blank");
    //   return
    // }
    try{
      setRarityLabelLoading(true);
       const response = await rarityInstance().post(
      "report/rarityLabelPdf",{
        report_id: reportId?.postId?.replace("#", ""),
          generateNewPdf: type === "new" ? true : false,
      }
    );

    const {  printUrl } = response?.data;

     console.log("response  of the report==>", response);
    setRarityLabelUrl(printUrl);
    setRarityLabelLoading(false);
    // window.open(printUrl, "_blank");
    console.log("response", response);

    }
    catch(error){
      setRarityLabelLoading(false);
      console.log("error", error);
      
    }
   
  };

  const handleShare = async (obj) => {
    const shareLink = `${serverPath}/share-rarity-report/${obj.Id}`;
    setUrlValue(shareLink);
  };
  const handleCopy = async () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 300);
    try {
      await rarityInstance().post("report/copy-share-link/Rarity", {
        reportId: reportId.postId,
        shareLink: urlValue,
      });
    } catch (error) {
      console.error("error in copy link===", error);
    }
  };

  const formatDateWebReport = (input) => {
    const dateObject = new Date(input);
    if (isNaN(dateObject.getTime())) {
      return "Invalid Date";
    }
  
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
  
    // Get month name
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const monthName = monthNames[month - 1];
  
    // Function to get ordinal suffix (1st, 2nd, 3rd, etc.)
    const getOrdinalSuffix = (day) => {
      if (day >= 11 && day <= 13) return `${day}th`; // Special case for 11th, 12th, 13th
      switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
      }
    };
  
    const formattedDate = `${monthName} ${getOrdinalSuffix(day)}, ${year}`;
    return formattedDate;
  }; 
  // const formatDate = (inputDate) => {
  //   const dateComponents = inputDate?.match(
  //     /(\w+) (\d+)(?:st|nd|rd|th), (\d+)/
  //   );
  //   if (!dateComponents) {
  //     return "Invalid Date";
  //   }
  //   return `${dateComponents[1].slice(0, 3)} ${ dateComponents[2]}, ${dateComponents[3]}`;
  // };

  const divRef = useRef(null);
  const [, setMinHeight] = useState("");

  const handleResize = () => {
    if (divRef.current) {
      const MinHeight = divRef.current.clientHeight;
      setMinHeight(MinHeight);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const sizeValueInit =
    reportData?.gia_report?.results?.data?.measurements?.length /
      reportData?.gia_report?.results?.data?.measurements?.width || 0;

  const sizeValue =
    Number(sizeValueInit.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]) || 0;

  useEffect(() => {
    if (
      reportData?.data?.shapeCategory === "Cushion" ||
      reportData?.data?.shapeCategory === "Radiant"
    ) {
      if (sizeValue <= 1.05) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.06 && sizeValue <= 1.14) {
        setImgScaleVal(1.075);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(1.15);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(1.225);
      } else if (sizeValue >= 1.35) {
        setImgScaleVal(1.3);
      }
    } else if (reportData?.data?.shapeCategory === "Emerald") {
      if (sizeValue <= 1.14) {
        setImgScaleVal(0.775);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(0.85);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(0.925);
      } else if (sizeValue >= 1.35 && sizeValue <= 1.44) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.45) {
        setImgScaleVal(1.075);
      }
    }
  }, [sizeValue]);

  const handleSaveReport = async () => {
    setisActive(true);
    const response = await rarityInstance().post("report/saveRarityReport", {
      reportId,
      recordName: reportData
        ? `${reportData?.data?.saturation} ${reportData?.data?.colorName ?? reportData?.data?.color} ${reportData?.data?.weight}ct`
        : "",
    });
    if (response) {
      const copyfilterdata = { ...response.data.report?.report };
      const { is_free, is_subscription, is_role, service } = getlocalStorage();
      copyfilterdata.free = is_free;
      copyfilterdata.subscription = is_subscription || "not active";
      copyfilterdata.role = is_role;
      copyfilterdata.type = "Rarity saved";
      copyfilterdata.service = service;

      rarityInstance().post("report/reportwebhook", copyfilterdata);
      setSavedNotification(true);
      setisActive(false);
      setTimeout(() => {
        setSavedNotification(false);
        navigate("/rarity-save-history");
      }, 1000);
    }
  };

  const dropdownItems = [
    {
      icon: HistoryIcons,
      route: "/saved-report?report",
      label: "Search History",
    },
    {
      icon: SaveIcons,
      route: "/rarity-save-history",
      label: "Saved Reports",
      sharefun: handleSaveReport,
    },
    { icon: SettingsIcons, route: `/settings`, label: "Report Settings" },
  ];

  if (reportData?.gia_report?.report_number) {
    dropdownItems.push({
      icon: DiamondIcon,
      route: `/valuation/?gia=${reportData?.gia_report?.report_number}`,
      label: "Ask for Valuation",
    });
  }

  const highlightText =
    reportData?.bubble_texts?.D18?.split("#")[1]?.split(" ")?.at(-1) || "";

  
  // console.log("showPopup",showPopup)
  // console.log("reportData", reportData);
  const handleOrder =async () => {
    setWooCommercePayload({
      gia: reportData?.data?.report_number ? reportData?.data?.report_number : null,
      productName: reportData?.data?.report_number ?`for ${reportData?.data?.weight}ct ${reportData?.data?.saturation} ${reportData?.data?.colorName} ${reportData?.data?.shape_name}. GIA# ${reportData?.data?.report_number}`: ` - ${reportData?.data?.weight}ct, ${reportData?.data?.saturation}, ${reportData?.data?.color}, ${reportData?.data?.shape} - Manual Input` ,
      weight: reportData?.data?.weight,
      color: reportData?.data?.color,
      intensity: reportData?.data?.saturation
    });

    setShowPopup(true);
    await rarityInstance().post("report/send-order-webhook", {
      gia: reportData?.data?.report_number ? reportData?.data?.report_number : null,
      productName: reportData?.data?.report_number ?`for ${reportData?.data?.weight}ct ${reportData?.data?.saturation} ${reportData?.data?.colorName} ${reportData?.data?.shape_name}. GIA# ${reportData?.data?.report_number}`: `Manual report - ${reportData?.data?.saturation}, ${reportData?.data?.color}, ${reportData?.data?.weight}ct, ${reportData?.data?.shape}, ${reportData?.data?.clarity}` ,
      weight: reportData?.data?.weight,
      color: reportData?.data?.color,
      intensity: reportData?.data?.saturation,
      nonMember:{
        email: Cookie.get("nonMemberEmail"),
        deviceId: Cookie.get("deviceId"),
        Id: reportId?.postId,
      }
    });
  }
  // console.log("showPopup",wooCommercePayload);
  // console.log("showPopup",reportData);

  const handleBranding = async () => {
    try{
      setBrandingEnable(!brandingEnable);
       const response = await rarityInstance().patch("report/update-report-branding", {
      reportId: reportId?.Id,
      enabledBranding: !brandingEnable
    });
    console.log("response",response);
    if (response?.data?.status ===200) {
      
    }

    }
    catch(e){
      console.log(e);
    }


  }
  return (
    <>
      {loading && <Loader type={"progress"} setLoading={setLoading} />}
      <Layout handleBackRairity={handleBackRairity} handleOpen={handleOpen} className="rarity-container-back">
        <div className="rarity-report-page updated_raritypage">
          <div className="rarity-report-head"></div>
          <div className="rarity-report-content rarity-report-conainer">
            <div className="container">
              
              <div className="rarity-container">
              <div className="rarity-tool rarity-updated-report">
               
              <div className="rarity-header-section grade-desktop-view">
                  <div className="rarity-header-right rarity-header-right-updated">
                    <div className="report-action-btn">
                         <div>
                     {!!reportData?.data?.report_number && (
                       <Button className="processBtn  tablet-view-rarity-order-btn" onClick={handleOrder} ><CharFadeText text = "Order Official Copy" /></Button>
                     )}
                      </div>
                      <Button
                        className="outline-btn"
                        onClick={() => handleCreateNewReport()}
                      >
                        <span> <PlusIcon />
                          New
                        </span>
                      </Button>
                      {!nonMember && (isPdf ? <Loading text="Loading" /> : 
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                            <span>PDF<DownloadIcon />
                            </span>
                          </>
                        )}
                      </Button>)
                      }
                      { !nonMember && (isActive ?
                      <Loading text="Saving" /> :
                      <Button
                        disabled={isActive}
                        className={`outline-btn `}
                        onClick={() => handleSaveReport()}
                      >
                        <span><SaveIcons />
                        {isActive ? <p>Loading...</p> : "Save"}</span>
                      </Button>)
                      }
                     {!nonMember && <div className="copy-btn-wrapper">
                        {urlValue && (
                          <CopyToClipboard
                            text={urlValue}
                            onCopy={(e) => handleCopy(e)}
                          >
                            <Button className="outline-btn">
                             <span> <ExportIcon /></span>
                            </Button>
                          </CopyToClipboard>
                        )}

                        <span
                          className={`copied-tooltip ${copied ? "show" : ""}`}
                        >
                          Copied
                        </span>
                      </div>}
                      {showBranding &&

        <div
         className={`custom-toggle-brand ${brandingEnable ? "active" : ""}`}
         onClick={handleBranding}
        >
          <div className="circle">
             {brandingEnable ? (
                <EyeIcon />
                  ) : (
                <EyeOffIcon />
              )}
           </div>

         <span className="toggle-text">
            {brandingEnable ? "Brand" : "Brand"}
        </span>
      </div>}
                   
                      
                  

                    </div>

                    {!nonMember && <VerticalDropdown dropdownItems={dropdownItems} />}
                  </div>
                </div>

                <div className="rarity-header-section grade-mob-view">
                  <div className="rarity-header-right">
                    <div className="report-action-btn">
                      <Button
                        className="outline-btn "
                        onClick={() => handleCreateNewReport()}
                      >
                        <p className="m-0"> <PlusIcon /></p>
                      </Button>
                      {!nonMember && (isPdf ? <Loading text="Loading" type="mobile" /> :
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                          <p className="m-0"> <DownloadIcon /></p> 
                          </>
                        )}
                      </Button>)
                      }
                     { !nonMember && (isActive?<Loading text="Saving" type="mobile" />:
                      <Button
                        disabled={isActive}
                        className="outline-btn  "
                        onClick={() => handleSaveReport()}
                      >
                        {isActive ? (
                          <Spinner animation="border" />
                        ) : (
                         <p className="m-0"> <SaveIcons /></p>
                        )}
                      </Button>)
                     }     
                     {!nonMember && <div className="copy-btn-wrapper">
                        {urlValue && (
                          <CopyToClipboard
                            text={urlValue}
                            onCopy={(e) => handleCopy(e)}
                          >
                            <Button className="outline-btn">
                              <p className="m-0"><ExportIcon /></p>
                            </Button>
                          </CopyToClipboard>
                        )}

                        <span
                          className={`copied-tooltip ${copied ? "show" : ""}`}
                        >
                          Copied
                        </span>
                      </div>}
                   {!nonMember && userCredits?.role ==="administrator" &&    <Button
                        className="outline-btn print-bg-btn"
                        style={{background:"#BF8F02",color:"#fff"}}
                        onClick={() => handlePrintReport()}
                      >
                        <WhitePrintIcon /> 
                      </Button>
                      
}

                    </div>
        
                    {!nonMember && <VerticalDropdown dropdownItems={dropdownItems} />}
                  </div>
                            {showBranding &&  <div
  className={`custom-toggle-brand ${brandingEnable ? "active" : ""}`}
  onClick={handleBranding}
>
  <div className="circle">
    {brandingEnable ? (
      <EyeIcon />
    ) : (
      <EyeOffIcon />
    )}
  </div>

  <span className="toggle-text">
    {brandingEnable ? "Brand" : "Brand"}
  </span>
</div>}
                </div>
              {nonMember &&    <div className="non-member-card">
                    <RarityOfficialCard  openModal={handleOpenModal} handleOrder={handleOrder} images={mobileImages} sliderImages={sliderImages} handleCreateNewReport={handleCreateNewReport} isGia={!!reportData?.data?.report_number}/>
                  </div>}
               
            


                <div className={`rarity-tool-grid updatedrarity-tool-grid   ${nonMember ? "non-member-rarity-tool-grid":""}`}>
                  <div className="updated_rarity_pdf">
                    <div className="rarity_report_top">
                      <div className="rarity_report_top_left">
                        <div className="rarity-fcrf-logo">
                          <img  src={`${ clientPath }/icons/FCRF_logo.svg`} alt="Logo" />
                        </div>
                        <div className={`${nonMember ? "non-member-report-page-top-left-desc":""}`}>
                           {nonMember &&<h5>Your Stone</h5>}
                          <div className={`rarity_report_top_left_desc report-page-top-left-desc ${nonMember ? "non-member-report-page-top-left-blur-desc":""}`}>

                         
                         
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Carat weight:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{parseFloat(reportData?.data?.weight).toFixed(2)}</div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Saturation:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{reportData?.data?.saturation}</div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Color:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">
                            {reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.color : `${reportData?.data?.colorName}${(reportData?.data?.color ==="Chameleon" && reportData?.data?.report_number) ? "*" :""}`} 
                            </div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Shape:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">
                            {reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.shape : reportData?.range_slider?.shapeName}
                            </div>
                          </p>
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`}>
                            <div className="rarity-gemological-text">
                              Clarity:
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`}></div>
                            <div className="rarity-gemological-text">{reportData?.data?.report_number === "" || !reportData?.data?.report_number ? reportData?.data?.giaclarity?? reportData?.data?.clarity : reportData?.data?.giaclarity}</div>
                          </p>
                       {
                        !(reportData?.data?.report_number === "" || !reportData?.data?.report_number) ? (
                          <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`} style={{
                            color: '#767676'
                          }}>
                            <div className="rarity-gemological-text">
                              GIA
                            </div>
                            <div className={`${(report_number ===""|| !report_number) ? "dotted-line-for-manual" : "dotted-line" }`} style={{borderBottom: '2px dotted #767676'}}></div>
                            <div className="rarity-gemological-text">
                            No. {reportData?.data?.report_number}
                            </div>
                          </p>
                        ) : <p className={`${(report_number ===""|| !report_number) ? "gemological-extra-line-for-manual" :"" }`} style={{
                          color: '#767676',
                          lineHeight: '34px',
                          marginTop: '-6px '
                          
                        }}>
                          <div className="rarity-gemological-text m-auto 
                          ">
                          Manual Input - No GIA
                          </div>
                        </p>
                       }

{(reportData?.data?.color ==="Chameleon" && reportData?.data?.report_number) &&  <div>
                            <span>*Chameleon</span>
                          </div> }

                        </div>

                        </div>
                        
                      </div>
                      <div className="rarity_report_top_right">
                        <div className="diamond-desc-img">
                          <div className="rarity-right-title report-page-rarity-right-title">
                            <h4>The Rarity Report</h4> 
                            <span>
                            <CIcon />
                            </span>
                            {/* <h6>Preview Edition</h6> */}
                           
                          </div>

                          <div className="rarity-right-img-data report-page-rarity-right-img-data">
                            <p className="report-date report-page-report-date">
                              {formatDateWebReport(reportData?.timestamp)}
                            </p>
                            {/* <p className="report-number m-0">
                              Report {reportData?.postId}
                            </p> */}
                            <p className="preview-edition m-0">
                              Preview Edition
                            </p>
                          </div>

                          <div className="divider"></div>

                          

                          <div className={`rarity-note report-page-rarity-note  ${!(report_number ===""|| !report_number) && "rarity-note-for-gi"}`}>
                            Rarity data refers to a natural color diamond with
                            the described gemological properties
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="diamond-grade ">
                      <div className="grade-section">
                        <p className="text-block">
                          <span className="main-text report-page-main-text">rarity</span>
                          <span className="highlight-text report-page-highlight-text">
                            ONE IN {highlightText}
                          </span>
                        </p>

                        <p className="text-block">
                          <span className="main-text report-page-main-text">market entry</span>
                          <span className="highlight-text  market-highlight report-page-highlight-text">
                            {" "}
                            {reportData?.bubble_texts?.H18?.replaceAll(
                              "#",
                              ""
                            )}{" "}
                          </span>

                        </p>
                      </div>
                    </div>

                    <div className="graph_section_rarity">
                      <div className="graph_section_rarity-left">
                        <h6 className="graph_section_text report-page_graph_section_text">
                          Market Distribution Percentage
                        </h6>
                        <div className="graph_section_chartdata">
                          <div className="updatedchart report-page-update-chart">
                            <MarketDistribution
                              graph_texts={tooltip_text}
                              labelValue={labelValue}
                              labelName={labelName}
                              loading={false}
                            />
                          </div>
                          <div>
                            <div className="divider"></div>

                            <h1 className="update-text">
                              The Fancy Color Research Foundation
                            </h1>
                          </div>
                        </div>
                      </div>

                      <div className={`graph_section_rarity-right graph_section_rarity-left ${nonMember? "non-member-denomination-section" :""}`}>
                        <h6 className="graph_section_text report-page_graph_section_text">
                          Denomination Brackets
                        </h6>
                        <div className="market-distribution-top">
                          <div className="market-distribution">
                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text  ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Remarkable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">Once</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">every 25y</div>
                              </h1>
                              <span
                                className={`distribution-label ${location.pathname ==='/report' ? "report-page-distribution-label ":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Remarkable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Remarkable
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""}   ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Exceptional"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                {" "}
                                <div className="tab-text-card">Once</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">
                                  every 13 - 24y
                                </div>{" "}
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Exceptional"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Exceptional
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extremely Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">Once</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">
                                  every 1 - 12y
                                </div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extremely Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Extremely Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">1-3</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Very Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">3-10</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Rare"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Rare
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extraordinary"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">10-40</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Extraordinary"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Extraordinary
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">40-180</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Very Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Very Special
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">180-400</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Special"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Special
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Outstanding"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">400-900</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Outstanding"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Outstanding
                              </span>
                            </div>

                            <div className="distribution-row">
                              <h1
                                className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Notable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                <div className="tab-text-card">900-10,000</div>
                                <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                <div className="tab-text-card">yearly</div>
                              </h1>
                              <span
                                className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                  reportData?.range_slider?.rarity_degree?.trim() ===
                                  "Notable"
                                    ? "remarkable-bold"
                                    : ""
                                }`}
                              >
                                Notable
                              </span>
                            </div>
                          </div>
                          <div className="divider-mt">
                            <div className="divider"></div>
                            <h1 className="update-text">
                            Data current as of report date
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                      {!(custom_branding === "1" && companyLogo) ? (
                       <div className="rarity_report_top update-rarity-bottom">
                            
                       <p>
                        {!reportData?.data?.report_number && 
                    <p >The rarity of the diamond is based on the diamond's GIA graded parameters.</p>
                    }
                         The data acquired from The Fancy Color Diamond Rarity
                         Report©. may change from time to time and is not a
                         guarantee nor a reflection of the diamond’s value. For
                         additional information regarding the data, and other
                         limitations, contact us at:{" "}
                         <a href="mailto:customers@fcresearch.org">
                           customers@fcresearch.org
                         </a>
                       </p>
                     </div>  
                    ) :
                    (
                      <div className="share-rarity-bottom">
                        <div className="share-rarity-bottom-text update-rarity-bottom"> 
                        <p>
                          {!reportData?.data?.report_number  && 
                    <p >The rarity of the diamond is based on the diamond's GIA graded parameters.</p>
                    }
                         The data acquired from The Fancy Color Diamond Rarity
                         Report©. may change from time to time and is not a
                         guarantee nor a reflection of the diamond’s value. For
                         additional information regarding the data, and other
                         limitations, contact us at:{" "}
                         <a href="mailto:customers@fcresearch.org">
                           customers@fcresearch.org
                         </a>
                       </p>
                        </div>
                        <div className="share-rarity-bottom-logo">
                        <img
                              src={companyLogo}
                              alt="Bottom Logo"
                            />
                        </div>
                       
                      
                    </div>
                    )}
                  </div>
                </div>




                <div className={`rarity-tool-grid old-rarity-report rarity-mob-updated ${nonMember && "non-member-for-mobile"}`}>
                  <div className="rarity-tool-left ">
                    <div>
                      <div className="rarity-heading-wrapper card-pd rarity-page-header">
                        <div className="rarity_report_top_heading ">
                         
                          <h1 className="relative rarity_report_head_top ">the rarity report

                          </h1>
                          <span>
                            <CIconMob />
                            </span>
                        </div>
                      </div>
                      <div className="rarity-right-img-data updated-mob-rarity">
                        <p className="report-date m-0">
                          {formatDateWebReport(reportData?.timestamp)}
                        </p>
                        {/* <p className="report-number m-0">
                          Report {reportData?.postId}
                        </p> */}
                           <p className="preview-edition m-0">
                              Preview Edition
                            </p>
                      </div>
                      <div className="divider update-divider"></div>
                      <div className={`rarity-note update-rarity-note mt-0 ${!(report_number ===""|| !report_number) && "rarity-note-for-gia"}`}>
                        Rarity data refers to a natural color diamond with the
                        described gemological properties
                      </div>

                      <div className="rarity_report_gemological_properties">
                        <p>
                          {parseFloat(reportData?.data?.weight).toFixed(2)} ct,{" "}
                          {reportData?.data?.saturation},{" "}
                          {reportData?.data?.color === "Chameleon" &&
                          reportData?.data?.report_number
                            ? `${reportData?.data?.colorName} - Chameleon`
                            : !reportData?.data?.report_number
                            ? reportData?.data?.color
                            : reportData?.data?.colorName}
                          ,{" "}
                          {reportData?.data?.report_number === "" ||
                          !reportData?.data?.report_number
                            ? reportData?.data?.shape
                            : reportData?.range_slider?.shapeName}
                          ,{" "}
                          {reportData?.data?.report_number === "" ||
                          !reportData?.data?.report_number
                            ? reportData?.data?.giaclarity ?? reportData?.data?.clarity
                            : reportData?.data?.giaclarity}{" "}
                        </p>
                        {reportData?.data?.report_number && (
                          <span>GIA No. {reportData?.data?.report_number}</span>
                        )}
                      </div>
                      <div className="rarity-update-right ratity-main-data rarity-mob-card">
                {/* <div className="rarity-update-right-content">
                <h2>The rarity report</h2>
                <h3>The legacy you pass on</h3>
                </div>
                <Button className="processBtn rarity-order-btn" onClick={handleOrder} >Order your hard copy</Button> */}
                <RarityOfficialCard  openModal={handleOpenModal} handleOrder={handleOrder} images={mobileImages} sliderImages={sliderImages}  handleCreateNewReport={handleCreateNewReport} isGia={!!reportData?.data?.report_number}/>
                {/* <Button className="processBtn rarity-order-btn" onClick={handleOrder} ><CharFadeText text = "Order your hard copy" /></Button> */}
               
              </div>
                    </div>

                    <div className="grade-mob-view">
                      <div className="rarity-highlighted-box highlight-box1">
                        <div className="text-block ">
                          <h6 className="main-text">rarity</h6>
                          <p className="highlight-text">
                            ONE IN {highlightText}
                          </p>
                        </div>
                      </div>

                      <div className="rarity-highlighted-box highlight-box1 highlight-box2">
                        <div className="text-block ">
                          <h6 className="main-text">market entry</h6>

                          <p className="highlight-text">
                            {reportData?.bubble_texts?.H18?.split("#")[0]}
                          </p>
                          <p className="highlight-text">
                            {reportData?.bubble_texts?.H18?.split("#")[1]}
                          </p>

                        </div>
                        {!showContent && (
                          <p
                            className="text-decoration-underline learn-about-text"
                            onClick={() => setShowContent(!showContent)}
                          >
                            learn about the rarity levels  <DownArrow />
                          </p>
                        )}

                        {
                          <div
                            className={`graph_section_rarity-right graph_section_rarity-left ${
                              showContent
                                ? "rarity-level-text-animation"
                                : "collapsed"
                            }`}
                          >
                            <h6 className="graph_section_text">
                              Denomination Brackets
                            </h6>
                            <div className="market-distribution-top">
                              <div className="market-distribution">
                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Remarkable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">Once</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">
                                      every 25y
                                    </div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Remarkable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Remarkable
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Exceptional"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    {" "}
                                    <div className="tab-text-card">Once</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">
                                      every 13 - 24y
                                    </div>{" "}
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Exceptional"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Exceptional
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extremely Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">Once</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">
                                      every 1 - 12y
                                    </div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extremely Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Extremely Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">1-3</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Very Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">3-10</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Rare"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Rare
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extraordinary"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">10-40</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Extraordinary"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Extraordinary
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">40-180</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Very Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Very Special
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">180-400</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Special"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Special
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Outstanding"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">400-900</div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Outstanding"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Outstanding
                                  </span>
                                </div>

                                <div className="distribution-row">
                                  <h1
                                    className={`distribution-text tab-distribution-text ${location.pathname ==='/report' ? "report-page-tab-distribution-text":""} ${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Notable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    <div className="tab-text-card">
                                      900-10,000
                                    </div>
                                    <div className={`dotted-text ${location.pathname ==='/report' ? "report-page-dotted-text":""}`}></div>
                                    <div className="tab-text-card">yearly</div>
                                  </h1>
                                  <span
                                    className={`${location.pathname ==='/report' ? "report-page-distribution-label ":""}${
                                      reportData?.range_slider?.rarity_degree?.trim() ===
                                      "Notable"
                                        ? "remarkable-bold"
                                        : ""
                                    }`}
                                  >
                                    Notable
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        </div>

                    </div>

                    <div className="card-pd card-height">
                      <GemologicalCharacteristics
                        graph_texts={tooltip_text}
                        labelValue={labelValue}
                        labelName={labelName}
                        loading={false}
                        section={"rarity"}
                      />
                    </div>


                  </div>

                  <div className="rarity-tool-right ">
                    <div className="rarity-time-report-no-wrapper grade-desktop-view">
                      <h5>{getFormattedDate(reportData?.timestamp)}</h5>
                      <p>Report {reportData?.postId}</p>
                    </div>
                    <div
                      className="grade-desktop-view cardHightRight1"
                      ref={divRef}
                    >
                      <RarityToolCard
                        cardDesc={
                          "Fancy Color Diamond appreciation revolves around beauty and rarity. The Rarity Report illustrates the market prevalence of a polished diamond. Whether a diamond is one of several hundred or is introduced to the market once a decade, rarity was, and always will be, a part of the epic story of a fancy color diamond."
                        }
                        loading={false}
                        line={2}
                        className="rarity-left-content-alignment"
                      />
                    </div>
                    <div
                      className={`grade-desktop-view ${
                        characteristics?.report_number
                          ? "share-rarity-grade"
                          : "right_grade"
                      }`}
                    >
                      <RarityHighlightedBox
                        range_slider={range_slider}
                        cardDesc={bubble_texts?.H18}
                        animationText={animationText}
                        loading={loading}
                      />
                    </div>

                    <RarityInfo range_slider={range_slider} />

                  </div>
                </div>

                {/* <div className="report-action-footer ">
                  <div className="report-action-btn action-btn-mob updated-btn-footer">
                    <Button
                      className="outline-btn"
                      onClick={() => handleCreateNewReport()}
                    >
                      <span>
                        <PlusIcon />
                        New
                      </span>
                    </Button>
                    {isPdf? <Loading text="Loading"/> :
                    <Button
                      className="outline-btn pdf-btn"
                      onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                    >
                      {isPdf ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          {" "}
                          <span>
                            <DownloadIcon />
                            PDF
                          </span>
                        </>
                      )}
                    </Button>
                    }
                    {isActive?<Loading text="Saving" />:  
                    <Button
                      disabled={isActive}
                      className="outline-btn"
                      onClick={() => handleSaveReport()}
                    >
                     <span> 
                      <SaveIcons />
                      {isActive ? <Spinner animation="border" /> : "Save"}
                      </span>
                    </Button>
}

                    <div className="copy-btn-wrapper">
                      {urlValue && (
                        <CopyToClipboard
                          text={urlValue}
                          onCopy={(e) => handleCopy(e)}
                        >
                          <Button className="outline-btn">
                           <span>
                             <ExportIcon />
                           </span>
                          </Button>
                        </CopyToClipboard>
                      )}

                      <span
                        className={`copied-tooltip ${copied ? "show" : ""}`}
                      >
                        Copied
                      </span>
                    </div>
                  </div>

                  <div className="rarity-header-section grade-mob-view">
                    <div className="rarity-header-right">
                      <div className="report-action-btn">
                        <Button
                          className="outline-btn"
                          onClick={() => handleCreateNewReport()}
                        >
                         <p className="m-0">
                           <PlusIcon />
                         </p>
                        </Button>
                        <Button
                          className="outline-btn pdf-btn"
                          onClick={() =>
                            handleDownLoadReport(reportData?.pdfurl)
                          }
                        >
                          {isPdf ? (
                            <Spinner animation="border" />
                          ) : (
                            <>
                              {" "}
                             <p className="m-0"><DownloadIcon /></p> 
                            </>
                          )}
                        </Button>
                       {isActive?<Loading text="Saving" type="mobile" />:
                        <Button
                          disabled={isActive}
                          className="outline-btn  "
                          onClick={() => handleSaveReport()}
                        >
                          {isActive ? (
                            <Spinner animation="border" />
                          ) : (
                           <p className="m-0">
                             <SaveIcons />
                           </p>
                          )}
                        </Button>
                        }

                        <div className="copy-btn-wrapper">
                          {urlValue && (
                            <CopyToClipboard
                              text={urlValue}
                              onCopy={(e) => handleCopy(e)}
                            >
                              <Button className="outline-btn">
                                <p className="m-0"><ExportIcon /></p>
                              </Button>
                            </CopyToClipboard>
                          )}

                          <span
                            className={`copied-tooltip ${copied ? "show" : ""}`}
                          >
                            Copied
                          </span>
                        </div>
                     {userCredits?.role === "administrator" &&     <Button
                        className="outline-btn print-bg-btn"
                        style={{background:"#BF8F02",color:"#fff"}}
                        onClick={()=>{ handlePrintReport()}}
                      >
                        <WhitePrintIcon />
                      </Button>
}
                      </div>
                    </div>
                    <div>
                      <div className="rarity-tool-bottom-text-padding1">
                        <p className="rarity-tool-text mb-2">
                          {!reportData?.data?.report_number && 
                    <p className="rarity-tool-text mb-0" >The rarity of the diamond is based on the diamond's GIA graded parameters.</p>
                    }
                          The data acquired from The Fancy Color Diamond Rarity
                          Report©. may change from time to time and is not a
                          guarantee nor a reflection of the diamond’s value. For
                          additional information regarding the data, and other
                          limitations, contact us at: customers@fcresearch.org
                        </p>

                        <p className="report-timestamp   rarity-report-time-stamp grade-mob-view">
                          <span className="update-text last-date">
                           Data current as of report date
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            <div className="rarity-updated-box-outer ">

                   <div className="d-none d-md-flex gap-2 justify-content-center ">
                   {!nonMember && userCredits?.role ==="administrator" && 
                      ( printLoading? <PrimaryLoading text="Printing"  type={"print"}/>: <Button

                        className="processBtn print-bg-btn1 rarity-label"
                       
                        onClick={() => handlePrintReport()}
                        
                      >
                       {printReport?.generateNewPdf ? <><WhitePrintIcon /> {" New Print"}</> : <><WhitePrintIcon /> {" Print"}</>} 
                         
                         

                      </Button>)
                      }
                      {!nonMember && userCredits?.role ==="administrator" && 
                      ( rarityLabelLoading ? <PrimaryLoading text="Generating"  type={"print"}/>: <Button

                        className="processBtn rarity-label"
                        // disabled={rarityLabelUrl ? true : false   }
                       
                        onClick={() => handleRarityLabelPdf()} 
                      >
                        {/* Rarity Label */}
                         
                { rarityLabelUrl ? <>{"Rarity Label"}</> : <>{"Rarity Label"}</>}

                      </Button>)
                      }
              </div>
           
              <div className={` ${!nonMember && userCredits?.role ==="administrator"? "mt-16":"mt-56"} rarity-update-right rarity-updated-box `}>
                
              <RarityOfficialCard  openModal={handleOpenModal}  handleOrder={handleOrder} images={images} sliderImages={sliderImages}   handleCreateNewReport={handleCreateNewReport} isGia={!!reportData?.data?.report_number}/>
              <img  src={logo_img} alt="banner-img" />
              </div>
               </div>
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop scrollClass={"scroll-up"} />
        {savedNotification && (
          <SaveNotificationModal
            message={"Report Saved successfully"}
            undoBtn={false}
          />
        )}
    
      <Modal
       show={modalIsOpen}
        onHide={closeModal}
        centered
        size="lg"
        contentClassName="bg-transparent border-0 p-0 slider-official-modal"
        >
     <Modal.Body className="p-0 text-center">
     <Swiper
      modules={[Navigation]} 
      initialSlide={selectedImageIndex}
      loop={true}
      navigation 
      onSlideChange={(swiper) => {
        setSelectedImageIndex(swiper.realIndex); 
        swiperRef.current?.slideTo(swiper.realIndex); 
      }}
    >
      {sliderImages.map((imgSrc, index) => (
        <SwiperSlide key={index}>
          <img
            src={imgSrc}
            alt={`Slide ${index + 1}`}
            style={{ width: "100%", height: "auto", borderRadius: "8px" }}
          />
        </SwiperSlide>
      ))}
     </Swiper>
    </Modal.Body>
   </Modal>


      </Layout>
      <PrintPopup showPopup={showPopup} setShowPopup={setShowPopup}  payload={wooCommercePayload}/>
       <Modal
        className="diary-notice-modal"
        show={show}
        onHide={() => setShow(false)}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <>
         <p> A printed report already exists for GIA number {printReport?.printId?.replace("#", "")} at {printReport?.report_date}. <span 
  
  className="click-as-parent-btn"
  onClick={() => { setShow(false); handlePrintReport("new") }}
>
  Click as parent to new
</span>
</p>
         <Button className="no-outline-btn processBtn" href={`${printReport?.printUrl}`} target="_blank" rel="noopener noreferrer">View Report</Button>
          </>
        </Modal.Body>
      </Modal>

      
    </>
  );
};

export default RarityReport;

const DownloadIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.156 15.242c.232 0 .447.097.6.25A.9.9 0 0 1 21 16.1v3.991l-.008.115-.02.107a.856.856 0 0 1-.833.687H3.856a.853.853 0 0 1-.845-.76C3 20.187 3 20.142 3 20.085v-3.992c0-.471.385-.852.85-.852a.852.852 0 0 1 .85.852v3.197h14.605v-3.197c0-.471.386-.852.85-.852zM12.01 3c.272 0 .522.114.703.29a.983.983 0 0 1 .29.704v9.215l2.51-2.515a.998.998 0 0 1 1.405 0 1.018 1.018 0 0 1-.017 1.408l-4.177 4.185c-.005.011-.017.017-.022.023a.984.984 0 0 1-.55.278c-.017 0-.034.006-.051.006l-.051.005H12l-.096-.005c-.017 0-.034-.006-.051-.006a.966.966 0 0 1-.55-.278l-.023-.023-4.177-4.185a.994.994 0 0 1-.289-.704c0-.255.097-.51.29-.704a.998.998 0 0 1 1.405 0l2.51 2.515V3.994c0-.545.448-.994.992-.994z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 13H3v-2h8V3h2v8h8v2h-8v8h-2z"
        fill="#bf8f02"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ExportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74707 4.00047H10.2111C10.4011 4.00053 10.584 4.07271 10.7229 4.20244C10.8617 4.33217 10.9461 4.50977 10.9591 4.69935C10.972 4.88893 10.9126 5.07636 10.7926 5.22377C10.6727 5.37117 10.5013 5.46757 10.3131 5.49347L10.2111 5.50047H6.74707C6.17711 5.50038 5.62835 5.71661 5.21164 6.10547C4.79493 6.49434 4.54133 7.02686 4.50207 7.59547L4.49707 7.75047V17.2505C4.49725 17.8204 4.71373 18.3691 5.10278 18.7856C5.49183 19.2021 6.02445 19.4555 6.59307 19.4945L6.74707 19.5005H16.2471C16.8172 19.5005 17.3661 19.2842 17.7828 18.8951C18.1996 18.506 18.453 17.9733 18.4921 17.4045L18.4971 17.2505V16.7525C18.4951 16.5611 18.5664 16.3762 18.6963 16.2357C18.8263 16.0952 19.005 16.0096 19.1959 15.9966C19.3869 15.9835 19.5756 16.044 19.7234 16.1656C19.8712 16.2871 19.967 16.4606 19.9911 16.6505L19.9971 16.7525V17.2505C19.9969 18.2103 19.6287 19.1335 18.9683 19.83C18.3079 20.5265 17.4055 20.9433 16.4471 20.9945L16.2471 21.0005H6.74707C5.78691 21.0005 4.8633 20.6323 4.16656 19.9717C3.46981 19.311 3.05302 18.4083 3.00207 17.4495L2.99707 17.2495V7.74947C2.99724 6.78964 3.36544 5.86642 4.02586 5.16992C4.68627 4.47341 5.58861 4.05666 6.54707 4.00547L6.74707 4.00047ZM14.5001 6.52047V3.75047C14.5 3.61251 14.538 3.47721 14.6098 3.35943C14.6816 3.24166 14.7846 3.14599 14.9073 3.08293C15.03 3.01987 15.1677 2.99188 15.3053 3.00203C15.4428 3.01218 15.575 3.06009 15.6871 3.14047L15.7691 3.20847L21.7631 8.95847C22.0431 9.22747 22.0691 9.65847 21.8401 9.95647L21.7631 10.0415L15.7691 15.7935C15.6695 15.8891 15.5455 15.9553 15.4108 15.985C15.276 16.0147 15.1356 16.0066 15.0051 15.9616C14.8747 15.9166 14.7591 15.8365 14.6713 15.7301C14.5834 15.6237 14.5266 15.4951 14.5071 15.3585L14.5001 15.2515V12.5265L14.1561 12.5565C11.7561 12.8065 9.45607 13.8875 7.24207 15.8165C6.72207 16.2695 5.91907 15.8415 6.00507 15.1585C6.66907 9.83847 9.45107 6.90747 14.2001 6.53947L14.5001 6.52047ZM16.0001 5.50747V7.25047C16.0001 7.44938 15.9211 7.64014 15.7804 7.7808C15.6397 7.92145 15.449 8.00047 15.2501 8.00047C11.3761 8.00047 8.97607 9.67647 7.93807 13.1575L7.85907 13.4355L8.21107 13.1985C10.4501 11.7375 12.7981 11.0005 15.2511 11.0005C15.4325 11.0005 15.6077 11.0663 15.7443 11.1856C15.8809 11.3049 15.9696 11.4697 15.9941 11.6495L16.0011 11.7505V13.4935L20.1601 9.50047L16.0001 5.50747Z"
        fill="#bf8f02"
      />
    </svg>
  );
};

const CIconMob = () => {
  return (
<svg width="9" height="9" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.1559 5.93679C11.1559 8.97316 8.75437 11.4236 5.73015 11.4236C2.72052 11.4236 0.45 8.98821 0.45 5.93679C0.45 2.88536 2.72052 0.45 5.73015 0.45C8.75437 0.45 11.1559 2.90042 11.1559 5.93679Z" fill="white" stroke="black" stroke-width="0.9"/>
<path d="M8.27954 4.68722C8.23072 4.51634 8.1819 4.36987 8.13308 4.24782C8.08426 4.11966 8.03238 4.00676 7.97746 3.90911C7.92863 3.80537 7.87066 3.71382 7.80353 3.63449C7.7425 3.55515 7.66927 3.47276 7.58383 3.38733C7.37633 3.17373 7.13832 3.01506 6.8698 2.91131C6.60738 2.80146 6.32665 2.74653 6.02762 2.74653C5.64924 2.74653 5.30444 2.81977 4.9932 2.96623C4.68806 3.1127 4.42564 3.32325 4.20594 3.59787C3.99234 3.86639 3.82756 4.19289 3.71161 4.57737C3.59566 4.96184 3.53768 5.38904 3.53768 5.85895C3.53768 6.46923 3.62007 7.00323 3.78484 7.46093C3.94962 7.91864 4.18458 8.27566 4.48972 8.53197C4.94742 8.89814 5.49362 9.08122 6.12831 9.08122C6.56161 9.08122 6.96134 8.99884 7.32751 8.83406C7.69368 8.66929 8.07205 8.40076 8.46263 8.02849L8.64571 8.21158C8.32837 8.63267 7.92253 8.95917 7.42821 9.19107C6.93998 9.42298 6.39684 9.53893 5.79876 9.53893C5.28003 9.53893 4.80706 9.45349 4.37987 9.28262C3.95267 9.11174 3.5865 8.87373 3.28136 8.56859C2.97622 8.25735 2.73822 7.88508 2.56734 7.45178C2.40256 7.01848 2.32018 6.53636 2.32018 6.00542C2.32018 5.40124 2.42392 4.8581 2.63142 4.37598C2.83891 3.88775 3.14405 3.47887 3.54683 3.14932C3.86418 2.893 4.22119 2.69466 4.61787 2.55429C5.01455 2.40783 5.41429 2.33459 5.81707 2.33459C6.33581 2.33459 6.84844 2.42003 7.35497 2.59091C7.52585 2.65194 7.66316 2.68245 7.76691 2.68245C7.87066 2.68245 7.95915 2.65194 8.03238 2.59091C8.11172 2.52988 8.16664 2.44444 8.19716 2.33459H8.41686L8.51755 4.68722H8.27954Z" fill="black"/>
</svg>


  );
};

const CIcon = () => {
  return (
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.1559 5.93679C11.1559 8.97316 8.75437 11.4236 5.73015 11.4236C2.72052 11.4236 0.45 8.98821 0.45 5.93679C0.45 2.88536 2.72052 0.45 5.73015 0.45C8.75437 0.45 11.1559 2.90042 11.1559 5.93679Z" fill="white" stroke="black" stroke-width="0.9"/>
<path d="M8.27954 4.68722C8.23072 4.51634 8.1819 4.36987 8.13308 4.24782C8.08426 4.11966 8.03238 4.00676 7.97746 3.90911C7.92863 3.80537 7.87066 3.71382 7.80353 3.63449C7.7425 3.55515 7.66927 3.47276 7.58383 3.38733C7.37633 3.17373 7.13832 3.01506 6.8698 2.91131C6.60738 2.80146 6.32665 2.74653 6.02762 2.74653C5.64924 2.74653 5.30444 2.81977 4.9932 2.96623C4.68806 3.1127 4.42564 3.32325 4.20594 3.59787C3.99234 3.86639 3.82756 4.19289 3.71161 4.57737C3.59566 4.96184 3.53768 5.38904 3.53768 5.85895C3.53768 6.46923 3.62007 7.00323 3.78484 7.46093C3.94962 7.91864 4.18458 8.27566 4.48972 8.53197C4.94742 8.89814 5.49362 9.08122 6.12831 9.08122C6.56161 9.08122 6.96134 8.99884 7.32751 8.83406C7.69368 8.66929 8.07205 8.40076 8.46263 8.02849L8.64571 8.21158C8.32837 8.63267 7.92253 8.95917 7.42821 9.19107C6.93998 9.42298 6.39684 9.53893 5.79876 9.53893C5.28003 9.53893 4.80706 9.45349 4.37987 9.28262C3.95267 9.11174 3.5865 8.87373 3.28136 8.56859C2.97622 8.25735 2.73822 7.88508 2.56734 7.45178C2.40256 7.01848 2.32018 6.53636 2.32018 6.00542C2.32018 5.40124 2.42392 4.8581 2.63142 4.37598C2.83891 3.88775 3.14405 3.47887 3.54683 3.14932C3.86418 2.893 4.22119 2.69466 4.61787 2.55429C5.01455 2.40783 5.41429 2.33459 5.81707 2.33459C6.33581 2.33459 6.84844 2.42003 7.35497 2.59091C7.52585 2.65194 7.66316 2.68245 7.76691 2.68245C7.87066 2.68245 7.95915 2.65194 8.03238 2.59091C8.11172 2.52988 8.16664 2.44444 8.19716 2.33459H8.41686L8.51755 4.68722H8.27954Z" fill="black"/>
</svg>


  );
};

const DownArrow = () => {
  return (
   <svg width="18" height="10" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L7 7L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};



const EyeOffIcon = ({ size = 24, color = "currentColor" }) => (
    // <div style={{ backgroundColor: "#b79259", borderRadius: "0%" , width: "48px", height: "32px", display: "flex", justifyContent: "center", alignItems: "center" }}>
  <svg
    fill={"#fff"}
    width={size}
    height={size}
    viewBox="0 0 1920 1920"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1591.462 544.364c129.295 100.893 238.985 236.548 316.774 392.233L1920 960.23l-11.658 23.634c-187.797 377.713-551.097 612.353-948.31 612.353-111.385 0-220.227-18.546-323.876-55.003l35.186-99.94c92.203 32.43 189.386 48.963 288.69 48.963 348.463 0 668.417-202.422 841.164-529.795-69.735-131.839-164.48-246.404-274.912-332.46ZM959.968 430.361c99.41 0 196.487 16.533 290.492 49.6 27.555 8.69 55.321 19.711 82.982 32.005l-189.704 189.705c-52.142-36.988-115.2-59.35-183.77-59.35-175.291 0-317.94 142.65-317.94 317.941 0 68.57 22.362 131.627 59.349 183.77l-212.703 212.596c-30.734-18.547-62.21-39.319-94.852-64.012-110.537-86.056-205.283-200.727-275.124-332.46C291.55 632.677 611.61 430.361 959.968 430.361Zm181.968 422.861c18.653 31.582 29.993 67.827 29.993 107.04 0 116.896-95.065 211.96-211.96 211.96-39.107 0-75.459-11.34-106.935-29.992l288.902-289.008Zm-181.968-104.92c39.213 0 75.458 11.446 107.04 29.992L778 1067.302c-18.546-31.582-29.992-67.827-29.992-107.04 0-116.79 95.064  -211.96 211.96-211.96Zm0 529.9c175.397 0 317.94-142.543 317.94-317.94 0-68.463-22.361-131.627-59.242-183.663l573.67-573.671L1717.408 128l-304.905 304.905c-43.027-21.408-86.373-40.273-128.66-53.52-103.542-36.457-212.49-55.004-323.875-55.004-397.213 0-760.62 234.64-948.204 612.354L0 960.368l11.764 23.634c77.79 155.685 187.479 291.34 317.516 392.656 28.403 21.514 55.64 40.167 82.24 57.23l-283.814 283.814 74.928 74.928 573.67-573.67c52.037 36.88 115.095 59.243 183.664 59.243"
      fillRule="evenodd"
    />
  </svg>
  // </div>
);

export const EyeIcon = ({ size = 24, color = "currentColor" }) => (
  // <div style={{ backgroundColor: "white", borderRadius: "0%" , width: "48px", height: "32px", display: "flex", justifyContent: "center", alignItems: "center"}}>
 <svg
    fill={"#b79259"}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M30.89,15.54A17,17,0,0,0,16,6,17,17,0,0,0,1.11,15.54L.87,16l.24.46A17,17,0,0,0,16,26a17,17,0,0,0,14.89-9.54l.24-.46ZM24,16a8,8,0,1,1-8-8A8,8,0,0,1,24,16ZM3.14,16a16.47,16.47,0,0,1,4.14-4.89,10,10,0,0,0,0,9.78A16.47,16.47,0,0,1,3.14,16Zm21.58,4.89a10,10,0,0,0,0-9.78A16.47,16.47,0,0,1,28.86,16,16.47,16.47,0,0,1,24.72,20.89Z" />
      <path d="M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z" />
    </g>
  </svg>
  // </div>
 
);

